import { ElementType } from 'react';
import { TextProps } from '@msc-b2c/interfaces/types';
import DOMPurify, { Config } from 'dompurify';
import './text.module.scss';

export const Text = ({ id, text, visible = true, styleOption = '', tagHtml = 'p' }: TextProps) => {
  const TextComponent: ElementType = tagHtml;
  const config: Config = { ADD_ATTR: ['target'] };

  return (
    text && (
      <div
        id={id}
        className={`${styleOption} ${!visible ? '-not-visible' : ''}`}
      >
        <div className="cmp-text">
          <TextComponent
            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text, config) as string }}
          ></TextComponent>
        </div>
      </div>
    )
  );
};
